export default "__VITE_ASSET__BRdBMPMa__"